

const INITIALSTATE = {
    data: null,
    editdata:null
}

const LoadCompanyProductReducer = (state = INITIALSTATE, action) => {
    switch (action.type) {
        case "LOADCOMPANYPRODUCT":
            return { ...state, product: action.data };
        case "EDITCOMPANYPRODUCT":
            return { ...state, company: action.data };
        
        // case "LOADCOMPANYADDRESS":
        //     return { ...state, company: action.data };
        
        case "LOADCOMPANYAVM":
            return { ...state, companyavm: action.data };
        default: return state;

    };
}

export default LoadCompanyProductReducer;